import React, {ReactElement} from "react";
import "./Loader.css"

export type LoaderCardProps = {
    children: ReactElement | ReactElement[]
}

export function LoaderCard(props: LoaderCardProps) {
    return <div className="full-width-height centered">
        <div className="loader-card centered success-card">
            {Array.isArray(props.children) ? [...props.children] : props.children}
        </div>
    </div>;
}